// ⛔️Generated file. Manual changes will be lost ⛔️

export class ServiceClientContainerConsts {
    public static readonly multipassUserService_userService: string = 'multipassUserService_userService';
    public static readonly multipassPlatformService_platformService: string = 'multipassPlatformService_platformService';
    public static readonly multipassLearningService_learningService: string = 'multipassLearningService_learningService';
}
